import useCanToggleAiIntegration from "shared/AiIntegration/access/useCanToggleAiIntegration";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";
import { useBulkToggleAiIntegration } from "shared/AiIntegration/useToggleAiIntegration";

import { AiIntegrationsBulkActions, AiIntegrationsBulkActionItem } from "../types";

const useEnableAiIntegrationBulkAction = (): AiIntegrationsBulkActionItem => {
  const [toggleAiIntegration] = useBulkToggleAiIntegration();
  const canToggleAiIntegration = useCanToggleAiIntegration();

  return {
    key: AiIntegrationsBulkActions.Enable,
    title: "Enable",
    resultTitle: "Enable integrations results",
    condition: (integration: AiIntegrationView) => {
      if (integration.enabled) {
        return { result: false };
      }

      return canToggleAiIntegration(integration);
    },
    mutation: (integration: AiIntegrationView) =>
      toggleAiIntegration({
        id: integration.id,
        enabled: true,
      }),
  };
};

export default useEnableAiIntegrationBulkAction;
